module.exports = __webpack_public_path__ + "assets/images/pages/creando/designpreis.png?02a05b1c";